import React, { ReactNode, useEffect, useMemo } from 'react'

import { useAppSelector } from 'reduxTyped'
import { billing } from 'common/billing/billingService/billingService'
import { BillingContext, BillingContextValue } from 'common/billing/contexts/BillingContext'
import { initBillingProAlertHandler } from 'common/billing/helpers/initShowProAlert'
import { getCurrentAccountID } from 'common/core/selectors/appSelectors'
import 'common/billing/experiments/registerAll'

import { isFlowPlayerRoute } from 'utils/router/tools'
import { typedRouting } from 'utils/router/typedRouting'

import { BillingModals } from './BillingModals'
import { useUpgradeDeeplinkListener } from './hooks/useUpgradeDeeplinkListener'

interface BillingProviderProps {
  children?: ReactNode | undefined
}

export const BillingProvider = ({ children }: BillingProviderProps) => {
  const billingContextValue: BillingContextValue = useMemo(() => ({ billing }), [])
  const accountId = useAppSelector(getCurrentAccountID)
  const accountIdFromUrl = typedRouting.useParams.registration().accountId

  useUpgradeDeeplinkListener({ billing })

  useEffect(() => {
    initBillingProAlertHandler()
  }, [])

  return (
    <BillingContext.Provider value={billingContextValue}>
      {/* User is in an account scope check. Flow player runs on a stub store without a real account */}
      {(accountId || accountIdFromUrl) && !isFlowPlayerRoute() && <BillingModals />}

      {children}
    </BillingContext.Provider>
  )
}
